export const G = {
  bg:        '#090B11',
  s1:        '#0F1320',
  s2:        '#141828',
  card:      '#181E2E',
  border:    '#222A3E',
  borderHov: '#2E3A55',
  gold:      '#C8A86C',
  goldFade:  'rgba(200,168,108,0.1)',
  goldBord:  'rgba(200,168,108,0.25)',
  green:     '#34D399',
  greenFade: 'rgba(52,211,153,0.1)',
  red:       '#F87171',
  redFade:   'rgba(248,113,113,0.1)',
  amber:     '#FBBF24',
  amberFade: 'rgba(251,191,36,0.1)',
  blue:      '#60A5FA',
  blueFade:  'rgba(96,165,250,0.1)',
  purple:    '#A78BFA',
  saffron:   '#FF9933',
  saffFade:  'rgba(255,153,51,0.1)',
  text:      '#EAE6DC',
  sub:       '#697594',
  dim:       '#374058',
}

// Indian asset categories (keep in sync with backend/src/routes/assets.js VALID_CATEGORIES)
export const ASSET_CATS = [
  'Bank Account', 'Fixed Deposit', 'Stocks & Mutual Funds',
  'US Stocks & ETFs', 'Sovereign Gold Bonds',
  'EPF', 'NPS', 'PPF', 'Sukanya Samriddhi (SSY)', 'Senior Citizens Savings (SCSS)', 'National Savings Certificate (NSC)',
  'Real Estate', 'Gold & Jewellery',
  'Vehicles', 'Business', 'Crypto', 'Other',
]
// Indian liability categories
export const LIAB_CATS = [
  'Home Loan', 'Car Loan', 'Personal Loan', 'Education Loan',
  'Credit Card', 'Gold Loan', 'Business Loan', 'Other',
]

export const A_PAL = ['#34D399','#60A5FA','#C8A86C','#F97316','#A78BFA','#FF9933','#F472B6','#22D3EE','#84CC16','#E879F9','#FB923C','#94A3B8']
export const L_PAL = ['#F87171','#FB923C','#FBBF24','#EF4444','#DC2626','#FCA5A5','#94A3B8','#D97706']

export const PLANS = {
  free:       { label: 'Free',       color: G.sub,     maxAssets: 5,        maxLiabs: 3,        insights: false, price: '₹0' },
  pro:        { label: 'Pro',        color: G.gold,    maxAssets: Infinity, maxLiabs: Infinity, insights: true,  price: '₹749/mo' },
  enterprise: { label: 'Enterprise', color: G.purple,  maxAssets: Infinity, maxLiabs: Infinity, insights: true,  price: 'Custom' },
}

// Indian number format: lakhs and crores
export const fk = n => {
  const abs = Math.abs(n)
  const sign = n < 0 ? '-' : ''
  if (abs >= 1e7)      return `${sign}₹${(abs/1e7).toFixed(2)} Cr`
  if (abs >= 1e5)      return `${sign}₹${(abs/1e5).toFixed(2)} L`
  if (abs >= 1000)     return `${sign}₹${(abs/1000).toFixed(1)}K`
  return `${sign}₹${Math.round(abs).toLocaleString('en-IN')}`
}

// Full formatted: ₹1,18,30,000
export const fFull = n =>
  `₹${Math.abs(Math.round(n)).toLocaleString('en-IN')}`

export const btn = (variant = 'gold') => ({
  display: 'inline-flex', alignItems: 'center', gap: 8,
  padding: '11px 22px', borderRadius: 9, cursor: 'pointer',
  fontSize: 14, fontWeight: 500, fontFamily: "'Outfit',sans-serif",
  transition: 'opacity 0.15s',
  ...(variant === 'gold'    ? { background: G.gold,     color: '#090B11', border: 'none' } : {}),
  ...(variant === 'ghost'   ? { background: 'none',     color: G.gold,    border: `1px solid ${G.goldBord}` } : {}),
  ...(variant === 'danger'  ? { background: G.redFade,  color: G.red,     border: `1px solid ${G.red}33` } : {}),
  ...(variant === 'subtle'  ? { background: G.s2,       color: G.sub,     border: `1px solid ${G.border}` } : {}),
  ...(variant === 'saffron' ? { background: G.saffFade, color: G.saffron, border: `1px solid ${G.saffron}44` } : {}),
})
